
import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/index.vue'
import { generateLocalRoutes } from './utils'
import { useUserStore } from '@/stores/user'

// 动态生成的路由（同步版本，快速加载）
const dynamicRoutes = generateLocalRoutes()

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0, left: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/login/index.vue'),
      meta: { public: true },
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/exception/404.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        ...dynamicRoutes,
        // 404 页面 - 放在最后捕获所有未匹配路由
        {
          path: ':pathMatch(.*)*',
          redirect: '/404',
        },
      ],
    },
  ],
})

// 路由守卫：未登录跳转登录页
// @ts-expect-error
router.beforeEach((to) => {
  // 公开页面直接放行
  if (to.meta.public) return true

  const userStore = useUserStore()
  if (!userStore.isLoggedIn) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }
  return true
})

export default router
